import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageManager } from '@cutting/main/shared/helper/local-storage-manager.helper';
import { fuseAnimations } from '@fuse/animations';
import { FuseConfigService } from '@fuse/services/config.service';
import { catchError, filter, takeUntil } from 'rxjs/operators';

import { LogoutService } from '../../../shared/services/logout.service';
import { UserService } from '@cutting/main/shared/services/user.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'cutting-change-email-by-key',
  templateUrl: './change-email-by-key.component.html',
  styleUrls: ['./change-email-by-key.component.scss'],
  animations: fuseAnimations,
})
export class ChangeEmailByKeyComponent implements OnInit, OnDestroy {
  userId = 0;

  userOrign: string;

  get auth(): boolean {
    return !!LocalStorageManager.client;
  }

  unsubscribe$: Subject<void> = new Subject();

  constructor(
    private fuseConfigService: FuseConfigService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private logoutService: LogoutService
  ) {
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        toolbar: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        sidepanel: {
          hidden: true,
        },
      },
    };
  }

  ngOnInit(): void {
    this.setEmailFromQueryPatams();
  }

  setEmailFromQueryPatams(): void {
    this.activatedRoute.queryParams
      .pipe(filter(params => params.key || params.user || params.userOrign))
      .subscribe(params => {
        if (params.userOrign) {
          this.userOrign = atob(params.userOrign);
        }

        if (params.user) {
          this.userId = +params.user;
          if (LocalStorageManager.regData !== this.userId) {
            LocalStorageManager.regData = this.userId;
            this.logoutService.logout();
          }
        }

        if (params.key) {
          this.userService
            .changeEmail(params.key)
            .pipe(
              takeUntil(this.unsubscribe$),
              catchError(() => this.router.navigate(['/']))
            )
            .subscribe();
        }
      });
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
